import React, {useEffect, useState} from 'react';
import "./UniqueVisitorChart.sass"
import Window from "../../../_containers/window/Window";
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {useDispatch, useSelector} from "react-redux";
import {IDLE, LOADING} from "../../../common/statuses";
import {getCountOfUnique} from "../../../_actions/auth/authAdminService";
import Spinner from "../../common/anonymous/Spinner";
import CircleButton from "../../../_components/common/buttons/CircleButton";
import CloseIcon from "@mui/icons-material/Close";
import {useNavigate} from "react-router";
import {FormControlLabel, Radio, RadioGroup} from "@mui/material";

export const UniqueVisitorChart = ({}) => {
    const [currentRadio, setCurrentRadio] = useState(7);

    const {data, status} = useSelector(state => state.auth.statistic);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (status === IDLE) {
            dispatch(getCountOfUnique(7))
        }
    }, [])

    if (status === IDLE || status === LOADING) {
        return <Spinner/>
    }

    console.log(data)
    const d = {
        name: "Количество уникальных посещений",
        data: data.map(d => {
            return {
                date: d.date,
                count: d.count,
            }
        }).sort((a, b) => a.date.localeCompare(b.date))
    }

    const handleRadioClick = (count) => {
        setCurrentRadio(count)
        dispatch(getCountOfUnique(count))
    }

    return (
        <Window>
            <div className="UniqueVisitorChart-title">
                <div className="UniqueVisitorChart-title-text">Количество уникальных посещений</div>
                <CircleButton onClick={() => navigate(-1)} Icon={CloseIcon}/>
            </div>
            <div className="UniqueVisitorChart-radio">
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                >
                    <FormControlLabel checked={currentRadio === 7} value="7" control={<Radio />} label="7 дней" onClick={() => handleRadioClick(7)} />
                    <FormControlLabel checked={currentRadio === 30} value="30" control={<Radio />} label="30 дней" onClick={() => handleRadioClick(30)} />
                    <FormControlLabel checked={currentRadio === 180} value="180" control={<Radio />} label="180 дней" onClick={() => handleRadioClick(180)} />
                    <FormControlLabel checked={currentRadio === 0} value="0" control={<Radio />} label="за всё время" onClick={() => handleRadioClick(0)} />
                </RadioGroup>
            </div>
            <div className="UniqueVisitorChart-chart-wrapper">
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        width={500}
                        height={300}
                        data={d}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="date"/>
                        <YAxis dataKey="count"/>
                        <Tooltip/>
                        <Legend/>
                        <Line type="monotone"
                              data={d.data}
                              dataKey="count"
                              name={d.name}
                              key={d.name} stroke="#82ca9d"/>

                    </LineChart>
                </ResponsiveContainer>
            </div>
        </Window>
    );
}